import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=93cd9028&scoped=true&"
import script from "./Journalism.vue?vue&type=script&lang=js&"
export * from "./Journalism.vue?vue&type=script&lang=js&"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=93cd9028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cd9028",
  null
  
)

component.options.__file = "Journalism.vue"
export default component.exports